module.exports = __webpack_public_path__ + "static/media/01zzaz.61880eec.mp3";